import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Emit, Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { notificationService, NotificationStyle } from '@gig/magic-messaging';
import { CoreXGamingLimitType } from '@gig/magic-sdk/dist/adapter/responsiblegaming/getUserTransactionLimits';
import { translateType, translateDuration, formatLimitAmount } from '../../../utils/limits.js';

var ConfirmationPromptComponent = /** @class */ (function (_super) {
    __extends(ConfirmationPromptComponent, _super);
    function ConfirmationPromptComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fields = {};
        _this.isLoading = false;
        _this.limitType = CoreXGamingLimitType;
        return _this;
    }
    Object.defineProperty(ConfirmationPromptComponent.prototype, "currency", {
        get: function () {
            return magic.session.getUser().currency;
        },
        enumerable: false,
        configurable: true
    });
    ConfirmationPromptComponent.prototype.setFields = function () {
        if (!this.unconfirmedLimits) {
            return;
        }
        this.fields = this.unconfirmedLimits.reduce(function (prev, limit) {
            prev[limit.id] = null;
            return prev;
        }, {});
    };
    ConfirmationPromptComponent.prototype.setConfirmed = function (id, value) {
        this.$v.fields[id].$model = value;
    };
    ConfirmationPromptComponent.prototype.saveLimits = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isLoading || this.$v.$invalid) {
                            return [2 /*return*/];
                        }
                        this.isLoading = true;
                        return [4 /*yield*/, Promise.all(this.getLimitValues().map(function (limit) { return __awaiter(_this, void 0, void 0, function () {
                                var unconfirmedLimit;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            unconfirmedLimit = this.unconfirmedLimits.find(function (unconfirmedLimit) {
                                                return unconfirmedLimit.id === limit.userLimitId;
                                            });
                                            if (!((unconfirmedLimit === null || unconfirmedLimit === void 0 ? void 0 : unconfirmedLimit.type) ===
                                                CoreXGamingLimitType.MAX_WAGER_CASINO ||
                                                (unconfirmedLimit === null || unconfirmedLimit === void 0 ? void 0 : unconfirmedLimit.type) ===
                                                    CoreXGamingLimitType.MAX_WAGER_SPORTS)) return [3 /*break*/, 2];
                                            return [4 /*yield*/, this.reviewMaxWagerTransactionLimit(limit.userLimitId, limit.isAccepted)];
                                        case 1:
                                            _a.sent();
                                            return [3 /*break*/, 6];
                                        case 2:
                                            if (!((unconfirmedLimit === null || unconfirmedLimit === void 0 ? void 0 : unconfirmedLimit.type) === CoreXGamingLimitType.SESSION)) return [3 /*break*/, 4];
                                            return [4 /*yield*/, this.reviewCumulativeSessionTransactionLimit(limit.userLimitId, limit.isAccepted)];
                                        case 3:
                                            _a.sent();
                                            return [3 /*break*/, 6];
                                        case 4: return [4 /*yield*/, this.reviewUserTransactionLimit(limit.userLimitId, limit.isAccepted)];
                                        case 5:
                                            _a.sent();
                                            _a.label = 6;
                                        case 6: return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.sent();
                        this.onCompleted();
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ConfirmationPromptComponent.prototype.onCompleted = function () {
        return;
    };
    ConfirmationPromptComponent.prototype.getLimitValues = function () {
        return Object.entries(this.fields).map(function (_a) {
            var id = _a[0], isAccepted = _a[1];
            return ({
                userLimitId: id,
                isAccepted: !!isAccepted,
            });
        });
    };
    ConfirmationPromptComponent.prototype.reviewUserTransactionLimit = function (id, confirmed) {
        return __awaiter(this, void 0, void 0, function () {
            var params, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            id: id,
                            confirmed: confirmed,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, magic.methods.responsibleGaming.reviewTransactionLimit(params)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        notificationService.show(this.$t('limits.confirmation-prompt.unexpected-error'), {
                            style: NotificationStyle.ERROR,
                            uniqueID: 'limits-confirmation-prompt-unexpected-error',
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ConfirmationPromptComponent.prototype.reviewMaxWagerTransactionLimit = function (id, confirmed) {
        return __awaiter(this, void 0, void 0, function () {
            var params, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            id: id,
                            confirmed: confirmed,
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, magic.methods.responsibleGaming.reviewMaxWagerLimit(params)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        notificationService.show(this.$t('limits.confirmation-prompt.unexpected-error'), {
                            style: NotificationStyle.ERROR,
                            uniqueID: 'limits-confirmation-prompt-unexpected-error',
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ConfirmationPromptComponent.prototype.reviewCumulativeSessionTransactionLimit = function (id, confirmed) {
        return __awaiter(this, void 0, void 0, function () {
            var params, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            id: id,
                            confirmed: confirmed,
                            sessionContextType: 'login',
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, magic.methods.responsibleGaming.reviewCumulativeSessionLimit(params)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _a.sent();
                        notificationService.show(this.$t('limits.confirmation-prompt.unexpected-error'), {
                            style: NotificationStyle.ERROR,
                            uniqueID: 'limits-confirmation-prompt-unexpected-error',
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        Prop(Array),
        __metadata("design:type", Array)
    ], ConfirmationPromptComponent.prototype, "unconfirmedLimits", void 0);
    __decorate([
        Watch('unconfirmedLimits', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ConfirmationPromptComponent.prototype, "setFields", null);
    __decorate([
        Emit('confirmed'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ConfirmationPromptComponent.prototype, "onCompleted", null);
    ConfirmationPromptComponent = __decorate([
        Component({
            name: 'corex-limit-confirmation-prompt',
            validations: function () {
                if (this.unconfirmedLimits) {
                    var limits = {
                        fields: {},
                    };
                    for (var _i = 0, _a = this.unconfirmedLimits; _i < _a.length; _i++) {
                        var limit = _a[_i];
                        limits.fields[limit.id] = {
                            required: required,
                        };
                    }
                    return limits;
                }
                return { fields: {} };
            },
            filters: {
                translateType: translateType,
                translateDuration: translateDuration,
                formatLimitAmount: formatLimitAmount,
            },
        })
    ], ConfirmationPromptComponent);
    return ConfirmationPromptComponent;
}(Mixins(MagicConfigMixin, validationMixin)));

export default ConfirmationPromptComponent;
